import { gql } from '@provision/graphql-client';

export const CONVERSATION_MESSAGE_REACTION_FIELDS = gql`
  fragment ConversationMessageReactionFields on ConversationMessageReaction {
    id
    conversationMessageReactionId
    conversationMessageId
    conversationId
    partnerId
    userId
    emoji
    createdAt
    platformUser {
      id
      firstName
      lastName
    }
  }
`;

export const MESSAGE_REACTIONS_FRAGMENT = gql`
  fragment MessageReactions on ConversationMessage {
    id
    conversationId
    partnerId
    reactions {
      ...ConversationMessageReactionFields
    }
  }
  ${CONVERSATION_MESSAGE_REACTION_FIELDS}
`;

export const REACTION_PLATFORM_USER_FRAGMENT = gql`
  fragment ReactionPlatformUser on PlatformUser {
    id
    firstName
    lastName
  }
`;

export const ADD_CONVERSATION_MESSAGE_REACTION_MUTATION = gql`
  mutation AddConversationMessageReaction($params: ConversationMessageReactionInput!) {
    addConversationMessageReaction(params: $params) {
      ...ConversationMessageReactionFields
    }
  }
  ${CONVERSATION_MESSAGE_REACTION_FIELDS}
`;

export const REMOVE_CONVERSATION_MESSAGE_REACTION_MUTATION = gql`
  mutation RemoveConversationMessageReaction($params: ConversationMessageReactionInput!) {
    removeConversationMessageReaction(params: $params) {
      removed
    }
  }
`;
